export default {
  watch: {
    currentCartId: {
      immediate: true,
      handler() {
        this.ensureCurrentCartData();
      },
    },
  },
  computed: {
    currentCartId() {
      return this.$store.state.cart.currentCart;
    },
    currentCartOrder() {
      return this.$store.state.cart.cartData;
    },
    currentCartOrderLoading() {
      return this.$store.state.cart.cartDataLoading;
    },
    currentCartOrderFailed() {
      return this.$store.state.cart.cartDataErrorFor === this.currentCartId;
    },
    currentCartOrderReady() {
      if (!this.currentCartId) {
        return true;
      }

      return this.$store.state.cart.cartDataLoadedFor === this.currentCartId;
    },
    currentCartOrderResolved() {
      return !this.currentCartId || this.currentCartOrderReady || this.currentCartOrderFailed;
    },
  },
  methods: {
    ensureCurrentCartData() {
      // currentCartOrderResolved is true when the fetch succeeded OR failed,
      // so a failed fetch will not be retried for the lifetime of this component.
      // Use fetchCartData({ forceNetwork: true }) directly if a retry is needed.
      if (
        !this.currentCartId
        || this.currentCartOrder
        || this.currentCartOrderLoading
        || this.currentCartOrderResolved
      ) {
        return;
      }

      this.$store.dispatch("fetchCartData", {
        apolloClient: this.$apollo.provider.defaultClient,
      });
    },
  },
};
